/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_activate_card_do_it_later = /** @type {(inputs: {}) => string} */ () => {
	return `Hacerlo después`
};

const en_organization_activate_card_do_it_later = /** @type {(inputs: {}) => string} */ () => {
	return `Do it later`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_activate_card_do_it_later = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_activate_card_do_it_later(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_activate_card_do_it_later", locale)
	if (locale === "es") return es_organization_activate_card_do_it_later(inputs)
	return en_organization_activate_card_do_it_later(inputs)
};
export { organization_activate_card_do_it_later as "organization.activate_card.do_it_later" }